import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from "firebase/auth";
import { getFirestore, doc, getDoc, setDoc } from "firebase/firestore";
import { getAnalytics, isSupported, logEvent } from "firebase/analytics";

// ── Paste your Firebase project config here ───────────────────────────────────
// Get this from: Firebase Console → Project Settings → Your Apps → SDK setup
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCJw1jqrNpBR1O5RbTkxrMB18wZ64Fuedw",
  authDomain: "the-aphg-teacher-planner.firebaseapp.com",
  projectId: "the-aphg-teacher-planner",
  storageBucket: "the-aphg-teacher-planner.firebasestorage.app",
  messagingSenderId: "986605282684",
  appId: "1:986605282684:web:9086bc142e84c63cda70f9",
  measurementId: "G-CXL0E7EBE0"
};

const app      = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db   = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();

// ── Analytics ─────────────────────────────────────────────────────────────────
// isSupported() resolves false in a handful of environments (some in-app browsers,
// ad blockers, private-browsing modes that block IndexedDB) — checking first avoids
// a thrown error breaking sign-in/load for those users. Once this initializes,
// Firebase automatically starts logging page_view and session_start events on its
// own — that alone is what populates Firebase Console → Analytics → Dashboard with
// daily/weekly/monthly active users and how often people come back. No extra code
// needed anywhere else in the app for those baseline stats.
export let analytics = null;
isSupported().then(function(supported){
  if (supported) analytics = getAnalytics(app);
}).catch(function(){ /* analytics unsupported in this environment — safe no-op */ });

// Safe wrapper for logging your own custom events later (e.g. "unlocked_prep",
// "used_auto_populate") — does nothing if analytics never initialized, instead of
// throwing.
export function logAnalyticsEvent(name, params) {
  if (analytics) logEvent(analytics, name, params);
}

// ── Auth helpers ──────────────────────────────────────────────────────────────
export async function signInWithGoogle() {
  const result = await signInWithPopup(auth, googleProvider);
  return result.user;
}
export async function signOutUser() {
  await signOut(auth);
}

// ── Firestore save/load ───────────────────────────────────────────────────────
export async function savePlannerState(uid, state) {
  const ref = doc(db, "planners", uid);
  await setDoc(ref, { state: JSON.stringify(state), updatedAt: new Date().toISOString() });
}
export async function loadPlannerState(uid) {
  const ref = doc(db, "planners", uid);
  const snap = await getDoc(ref);
  if (snap.exists()) {
    return JSON.parse(snap.data().state);
  }
  return null;
}